import * as React from 'react';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

export default function ControlledOpenSelect({ onSelectionChange }) {
  const [age, setAge] = React.useState('837');
  const [open, setOpen] = React.useState(false);

  const handleChange = (event) => {
    const value = event.target.value;
    setAge(value);
    if (onSelectionChange) {
      onSelectionChange(value);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  return (
    <div>
      <FormControl>
        <Select
          open={open}
          onClose={handleClose}
          onOpen={handleOpen}
          value={age}
          onChange={handleChange}
          sx={{
            height: 50,
            width: 60,
            marginRight: '20px',
            border: 'none',
            backgroundColor: 'transparent',
            '& .MuiSelect-select': {
              padding: 0,
              textAlign: 'center',
              fontSize: '14px',
            },
            '& .MuiOutlinedInput-notchedOutline': {
              border: 'none',
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
              border: 'none',
            },
            '& .MuiSvgIcon-root': {
              fontSize: '1.25 rem',
            },
          }}
          MenuProps={{
            PaperProps: {
              sx: {
                boxShadow: '0px 4px 4px 0px #00000040',
                borderRadius: '6px',
                border: '1px solid #D8D8D8',
                backgroundColor: '#F1F4F9',
                '& .MuiMenuItem-root': {
                  paddingX: '30px',
                  borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
                  '&:last-child': {
                    borderBottom: 'none',
                  },
                  '&.Mui-selected': {
                    backgroundColor: '#F1F4F9',
                    fontWeight: 'bold',
                  },
                  '&:hover': {
                    backgroundColor: '#D8D8D8',
                  },
                },
              },
            },
          }}
        >
          <MenuItem value="835">835</MenuItem>
          <MenuItem value="837">837</MenuItem>
        </Select>
      </FormControl>
    </div>
  );
}
